import React, { useEffect, useState } from 'react';
import { Autocomplete, useJsApiLoader } from '@react-google-maps/api';
import StyledInput from '../styledComponents/StyledInput';

const libraries = ['places'];

const AsyncMap = ({ address, handleChange,setFieldValue , editProfileComp,...props }) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_URL,
    libraries,
  });
  const [inputValue, setInputValue] = useState('');


  const handleBlur = () => {
    if(inputValue?.trim() === '' && editProfileComp){
      setInputValue('');
      setFieldValue('address' , '');
      setFieldValue('address2' , '');
      setFieldValue('googlePlaceId' , '');
      setFieldValue('googleMapLocationUrl', '');
      setFieldValue('city' , '');
      setFieldValue('country' , '');
      setFieldValue('zipCode' , '');
      setFieldValue('state' , '');
      setFieldValue('latitude' , '');
      setFieldValue('longitude' , '');
    }
    else {
      setInputValue(address ?? '');
    }
  };

  useEffect(() => {
    if (address) {
      setInputValue(address);
    }
  }, [address]);

  const [autoComplete, setAutoComplete] = useState(null);

  if (!isLoaded) {
    return <></>;
  }
  return (
    <Autocomplete
      onLoad={setAutoComplete}
      onPlaceChanged={() => handleChange(autoComplete)}
    >
      <StyledInput
        type="text"
        placeholder="Customized your placeholder"
        value={inputValue}
        onBlur={handleBlur}
        autoComplete="off"
        aria-autocomplete="list"
        onChange={(e) => {
          setInputValue(e.target.value);
        }}
        {...props}
      />
    </Autocomplete>
  );
};

export default AsyncMap;
